<template>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
        <notifications></notifications>
        <sidebar-fixed-toggle-button/>
        <side-bar
            :background-color="sidebarBackground"
            :short-title="$t('sidebar.shortTitle')"
            :title="customerName"
            :logo="logo"
        >
            <template slot-scope="props" slot="links">
                <sidebar-item
                    :link="{
            name: $t('sidebar.dashboard'),
            icon: 'home',
            path: '/dashboard'
          }"
                >
                </sidebar-item>

                <sidebar-item
                    v-if="canView('view-school')"
                    :link="{
            name: $t('sidebar.school'),
            icon: 'building',
            path: '/school'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-number')"
                    :link="{
            name: $t('sidebar.phonenumbers'),
            icon: 'phone',
            path: '/numbers'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-device')"
                    :link="{
            name: $t('sidebar.sipdevices'),
            icon: 'phone-office',
            path: '/devices'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-invoice')"
                    :link="{
            name: $t('sidebar.billing'),
            icon: 'file-invoice-dollar',
            path: '/billing'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-voicemailbox')"
                    :link="{
            name: $t('sidebar.voicemailbox'),
            icon: 'voicemail',
            path: '/voicemailbox'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-cdr')"
                    :link="{
            name: $t('sidebar.callrecords'),
            icon: 'table',
            path: '/callrecords'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-ivr')"
                    :link="{
            name: $t('sidebar.ivrs'),
            icon: 'headset',
            path: '/ivrs'
          }"
                >
                </sidebar-item>

                <sidebar-item
                    v-if="canView('view-musiconhold')"
                    :link="{
            name: $t('sidebar.musiconhold'),
            icon: 'pause',
            path: '/musiconhold'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-internal')"
                    :link="{
            name: $t('sidebar.internal'),
            icon: 'building',
            path: '/internal'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-queue')"
                    :link="{
            name: $t('sidebar.queues'),
            icon: 'user-clock',
            path: '/queues'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-ringgroup')"
                    :link="{
            name: $t('sidebar.ringgroups'),
            icon: 'users',
            path: '/ringgroups'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-timecondition')"
                    :link="{
            name: $t('sidebar.timeconditions'),
            icon: 'clock',
            path: '/timeconditions'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-contacts')"
                    :link="{
            name: $t('sidebar.contacts'),
            icon: 'user',
            path: '/contact'
          }"
                >
                </sidebar-item>
                <sidebar-item
                    v-if="canView('view-school')"
                    :link="{
            name: $t('sidebar.bulletins'),
            icon: 'list-music',
            path: '/bulletins'
          }"
                >
                </sidebar-item>
            </template>
        </side-bar>
        <div class="main-panel" :data="sidebarBackground">
            <dashboard-navbar></dashboard-navbar>
            <router-view name="header"></router-view>

            <div
                :class="{ content: !$route.meta.hideContent }"
                @click="toggleSidebar"
            >
<!--                <base-alert type="info">-->
<!--                    <span><strong> Update </strong> - We've moved all files older than 30 to a new tab called "Old Files"</span>-->
<!--                </base-alert>-->
                <zoom-center-transition :duration="200" mode="out-in">


                    <!-- your content here -->
                    <router-view></router-view>
                </zoom-center-transition>
            </div>
            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>
<script>
    /* eslint-disable no-new */
    import PerfectScrollbar from 'perfect-scrollbar';
    import 'perfect-scrollbar/css/perfect-scrollbar.css';
    import DashboardNavbar from './DashboardNavbar.vue';
    import ContentFooter from './ContentFooter.vue';
    import DashboardContent from './Content.vue';
    import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
    import {SlideYDownTransition, ZoomCenterTransition} from 'vue2-transitions';
    import md5 from 'md5';

    function hasElement(className) {
        return document.getElementsByClassName(className).length > 0;
    }

    function initScrollbar(className) {
        if (hasElement(className)) {
            new PerfectScrollbar(`.${className}`);
        } else {
            // try to init it later in case this component is loaded async
            setTimeout(() => {
                initScrollbar(className);
            }, 100);
        }
    }

    export default {
        components: {
            DashboardNavbar,
            ContentFooter,
            SidebarFixedToggleButton,
            DashboardContent,
            SlideYDownTransition,
            ZoomCenterTransition
        },
        data() {
            return {
                sidebarBackground: 'blue' //vue|blue|orange|green|red|primary
            };
        },
        computed: {
            customerName() {
                return this.$store.getters['customer/name']
            },
            customerEmail() {
                return this.$store.getters['customer/email']
            },
            customerPermissions() {
                return this.$store.getters['customer/permissions']
            },
            authAdmin() {
                return this.$store.getters.isAdmin
            },
            logo() {
                if (this.customerEmail === null) {
                    return;
                }
                return 'https://www.gravatar.com/avatar/' + md5(this.customerEmail) + 'https://ui-avatars.com/api/name=' + this.customerName + '200/1/true/true';
            },
        },
        methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            },
            canView(permission) {
                return this.customerPermissions.includes(permission) || this.authAdmin;
            },
            initScrollbar() {
                let docClasses = document.body.classList;
                let isWindows = navigator.platform.startsWith('Win');
                if (isWindows) {
                    // if we are on windows OS we activate the perfectScrollbar function
                    initScrollbar('sidebar');
                    initScrollbar('sidebar-wrapper');

                    docClasses.add('perfect-scrollbar-on');
                } else {
                    docClasses.add('perfect-scrollbar-off');
                }
            }
        }
    };
</script>
<style lang="scss">
    $scaleSize: 0.95;
    @keyframes zoomIn95 {
        from {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }
        to {
            opacity: 1;
        }
    }

    .main-panel .zoomIn {
        animation-name: zoomIn95;
    }

    @keyframes zoomOut95 {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }
    }

    .main-panel .zoomOut {
        animation-name: zoomOut95;
    }
</style>
